import React from "react";
import { Box, Typography, FormControl, Select, MenuItem } from "@mui/material";

export default function LocationSelector({ locations, selectedLocation, setSelectedLocation }) {
  return (
    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography variant="subtitle1">Select Location:</Typography>
      <FormControl size="small" sx={{ minWidth: 220 }}>
        <Select
          value={selectedLocation || ""}
          onChange={e => setSelectedLocation(e.target.value)}
          displayEmpty
          renderValue={selected => {
            if (!selected) return <span style={{ color: '#aaa' }}>Select a location...</span>;
            const found = locations.find(l => l.id === selected);
            return found ? found.name : <span style={{ color: '#aaa' }}>Select a location...</span>;
          }}
        >
          {locations.length === 0 && (
            <MenuItem disabled value="">
              No locations found
            </MenuItem>
          )}
          {locations.map(l => (
            <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
